/* @flow weak */
import enumerate from 'lib/enumerate';

export const ActionTypes = enumerate([
  'LOAD_BLOCKED_USERS',
]);



// WEBPACK FOOTER //
// ./src/constants/BlockedUserConstants.js